module.exports = __webpack_public_path__ + "public/images/generated-explore-biology.7a2d7bf23c2640080dc46c6d8a6e9a12.jpg";